import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Constants } from '../../shared/Constants';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class BillingService {

  constructor(private http: HttpClient) { }


  getYearBilling() {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.get(Constants.URL_BACKEND + '/HS_GetYearBilling/', { headers: headers });
}

  getBilling() {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/billing-header', { headers: headers });
  }


  getBillingFilterClient( cliente, year) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/billing-header-filterclient', { params: { cliente: cliente, year: year }, headers: headers });
  }


  getBillingFilter(filter) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/billing-header-filter', { params: { filter: filter }, headers: headers });
  }

  getOneBilling(id) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/billing-header/' + id, { headers: headers });
  }

  getBillsByBudget(budgetId) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/billing-header-by-budget/' + budgetId, { headers: headers });
  }

  insertBill(data) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.post(Constants.URL_BACKEND + '/billing-header', { data: data }, { headers: headers });
  }

  anulateBill(id) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.put(Constants.URL_BACKEND + '/anulate-billing-header/' + id, { data: {} }, { headers: headers });
  }

  /*getpdf(id_pronos_bill){
    var rutaServicio = "/exportElectronicInnvoce/" + id_pronos_bill
    var header = btoa(localStorage.getItem('jwtPro'))
    var params = 'header='+header;
    window.open([ 'http://pronos3be.holinsys.net' + rutaServicio, params].join('?'));
  }*/

  insertBillingDetails(idBillingHeader, data){
    data.forEach(element => {
      element.id_billing_header = idBillingHeader;
    });
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.post(Constants.URL_BACKEND + '/billing-detail', { data: data }, { headers: headers });
  }

  getPDF(data) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.put(Constants.URL_BACKEND + '/bill-toPDF', data, { headers: headers, responseType: 'blob' });
  }
  getBajaPDF(data) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.put(Constants.URL_BACKEND + '/baja-toPDF', data, { headers: headers, responseType: 'blob' });
  }
  exportarPiezasXls(colectionID , start_date, end_date) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    const body = { colectionID : colectionID ,fechaInicio: start_date, fechaFinal: end_date };
    
    return this.http.post(Constants.URL_BACKEND + '/piezasOTxls' ,body, { headers: headers, responseType: 'blob' })
      .pipe(catchError((error: HttpErrorResponse) => {
        if ( (error.status === 500 || error.status === 400) && error.error instanceof Blob && error.error.type === "application/json") {
          // convertir el Blob en JSON
          return new Observable(observer => {
            let reader = new FileReader();
            reader.onload = (e: Event) => {
              try {
                const errmsg = JSON.parse((<any>e.target).result);
                observer.error(errmsg);
              } catch (e) {
                observer.error({
                  code: error.status,
                  message: "Unknown Error"
                });
              }
              observer.complete();
            };
            reader.onerror = (e: Event) => {
              observer.error({
                code: error.status,
                message: "Error Reading Error"
              });
              observer.complete();
            };
            reader.readAsText(error.error);
          });
        } else {
          return new Observable(observer => {
            observer.error(error);
            observer.complete();
          });
        }
      }));
  }
  exportarPiezas(colectionID , start_date, end_date) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    const body = { colectionID : colectionID ,fechaInicio: start_date, fechaFinal: end_date };
    
    return this.http.post(Constants.URL_BACKEND + '/piezasOT' ,body, { headers: headers, responseType: 'blob' })
      .pipe(catchError((error: HttpErrorResponse) => {
        if ( (error.status === 500 || error.status === 400) && error.error instanceof Blob && error.error.type === "application/json") {
          // convertir el Blob en JSON
          return new Observable(observer => {
            let reader = new FileReader();
            reader.onload = (e: Event) => {
              try {
                const errmsg = JSON.parse((<any>e.target).result);
                observer.error(errmsg);
              } catch (e) {
                observer.error({
                  code: error.status,
                  message: "Unknown Error"
                });
              }
              observer.complete();
            };
            reader.onerror = (e: Event) => {
              observer.error({
                code: error.status,
                message: "Error Reading Error"
              });
              observer.complete();
            };
            reader.readAsText(error.error);
          });
        } else {
          return new Observable(observer => {
            observer.error(error);
            observer.complete();
          });
        }
      }));
  }
  
  

  getBillingClients(){
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/billing-clients',{ headers: headers});
  }

  getBillingGraph(id, dateIni, dateEnd){
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/billing-graph/'+id,{ params: { dateIni: dateIni, dateEnd: dateEnd}, headers: headers});
  }

  getBillByBudget(id){
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/billByBudget/'+id,{ headers: headers})
  }

  getReportBillingDetailByDates(dateIni: string, dateFin: string) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set(
      'Authorization',
      'Basic ' + btoa(localStorage.getItem('jwt'))
    );

    const optionArgs = {
      headers: headers,
      responseType: 'blob' as 'json'
    }

    return this.http.get(Constants.URL_BACKEND + '/billing-detail-report-excel-dates?date1=' + dateIni + '&date2=' + dateFin, optionArgs);
  }

  getReportBillingDetailByClient(clientId) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set(
      'Authorization',
      'Basic ' + btoa(localStorage.getItem('jwt'))
    );

    const optionArgs = {
      headers: headers,
      responseType: 'blob' as 'json'
    }

    return this.http.get(Constants.URL_BACKEND + '/billing-detail-report-excel-client?clientId=' + clientId, optionArgs);
  }


}



// WEBPACK FOOTER //
// ./src/app/system/services/billing.service.ts